@if (isLoading()) {
  <mat-spinner diameter="32"></mat-spinner>
}

<im-sow-form
  [inspectionId]="inspectionId"
  (loaded)="onChildLoaded()"
></im-sow-form>
